import { FiscalpopRequestOptions, postForm, postRaw } from './fiscalpop.base';

export const uploadKey = <T = any>(
    authToken: string,
    file: File,
    password: string,
    options: FiscalpopRequestOptions = {},
): Promise<T> => {
    const formData = new FormData();
    formData.append('upload', file);
    formData.append('password', password);
    return postForm<T>(`/upload/key/${authToken}`, formData, options);
};

export const uploadCer = <T = any>(
    authToken: string,
    file: File,
    options: FiscalpopRequestOptions = {},
): Promise<T> => {
    const formData = new FormData();
    formData.append('upload', file);
    return postForm<T>(`/upload/cer/${authToken}`, formData, options);
};

export interface UploadLogoResponse {
    logoUrl: string;
}

export const uploadLogo = (
    authToken: string,
    file: File,
    extension: string,
    options: FiscalpopRequestOptions = {},
): Promise<UploadLogoResponse> => {
    return postRaw<UploadLogoResponse>(`/clients/logo/${authToken}`, file, { extension }, options);
};
